import { createAction } from "@reduxjs/toolkit"

export const getChartSignUpAsync = createAction(
   "chartSignUp/getChartSignUpDataAsync"
)

export const exportExcelChartSignUpAsync = createAction<any>(
   "chartSignUp/exportExcelChartSignUpAsync"
)
